import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dialog-show-items',
  templateUrl: './dialog-show-items.component.html',
  styleUrls: ['./dialog-show-items.component.css']
})
export class DialogShowItemsComponent implements OnInit {
  listaItems= [];

  DataSource = new MatTableDataSource<any>([]);
  DisplayedColumns: string[] = ['item', 'descripcion', 'cantidad', 'precioUnidad', 'inafecto', 'igv', 'monto', 'actions'];

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DialogShowItemsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

      this.listaItems = data.lista;
      this.listaItems.forEach((item: any) => {
        item.edit = true
      });
     }

  ngOnInit(): void {
    this.DataSource.data = this.listaItems;
  }

  close(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }

  changeEdit(ele: any, i: any){
    ele.edit = false;
    Object.assign(this.DataSource.data[i], ele);
  }

  saveEdit(ele: any, i: any){
    ele.monto = Number(ele.cantidad)*Number(ele.precioUnidad);
    ele.cantidad = Number(ele.cantidad);
    ele.precioUnidad = Number(ele.precioUnidad);
    ele.igv = Number(ele.igv);
    ele.edit = true;
    Object.assign(this.DataSource.data[i], ele);
  }

  cancelEdit(ele: any, i: any){
    let temp = this.DataSource.data[i];
    temp.edit = true;
    Object.assign(this.DataSource.data[i], temp);

    //this.DataSource.data
  }

}
